import * as React from 'react';
import * as styles from './TreeLink.css';
import { inject, observer } from 'mobx-react';
import { TreeLinkStore } from './store/TreeLinkStore';
import { TreeLinkNode } from './treeLinkNode/TreeLinkNode';
import { EditPanel } from './panel/EditPanel';
import { ITreeLinkNode } from '../../interfaces/ITreeLinkNode';

export interface ITreeLinkProps {
  treeLinkStore?: TreeLinkStore;
  showDropZoneForId: string;
  removeTree?: () => void;
  rerender: () => void;
  save: (treeLink: ITreeLinkNode) => void;
  onClick: (node: ITreeLinkNode) => void;
  onDragEnter: (node: ITreeLinkNode) => void;
  onDrop: (node: ITreeLinkNode) => void;
  onDrag: (node: ITreeLinkNode) => void;
  showPage: (page: string) => void;
}

@inject('treeLinkStore')
@observer
export class TreeLink extends React.Component<ITreeLinkProps> {

  constructor(props: ITreeLinkProps) {
    super(props);
  }

  public render(): JSX.Element {
    return (
      <div
        className={styles.TreeLinkList}
        style={{
          backgroundColor: this.props.treeLinkStore.backgroundColor ? this.props.treeLinkStore.backgroundColor : "tranparent",
          borderRadius: this.props.treeLinkStore.borderRadius,
          color: this.props.treeLinkStore.textColor ? this.props.treeLinkStore.textColor : (this.props.treeLinkStore.hasDarkBackground ? "#ffffff" : "#333333"),
          boxShadow: this.props.treeLinkStore.dropShadow ? "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px" : "none",
          padding: (this.props.treeLinkStore.backgroundColor !== undefined && this.props.treeLinkStore.backgroundColor !== null && this.props.treeLinkStore.backgroundColor !== "" && this.props.treeLinkStore.backgroundColor !== "transparent") || this.props.treeLinkStore.dropShadow ? "7px 20px 10px 20px" : 0,
          ...this.props.treeLinkStore.styles
        }}
      >
        <TreeLinkNode
          removeTree={() => this.props.removeTree()}
          node={this.props.treeLinkStore.treeLink}
          fontSlots={this.props.treeLinkStore.fontSlots}
          rerender={() => this.props.rerender()}
          onClick={(node: ITreeLinkNode) => this.props.onClick(node)}
          showDropZoneForId={this.props.showDropZoneForId}
          onDragEnter={(node: ITreeLinkNode) => this.props.onDragEnter(node)}
          onDrag={(node: ITreeLinkNode) => this.props.onDrag(node)}
          onDrop={(node: ITreeLinkNode) => this.props.onDrop(node)}
          showPage={(page: string) => this.props.showPage(page)}
        />
        {this.props.treeLinkStore.inEditMode !== undefined &&
          <EditPanel
            rerender={() => this.props.rerender()}
            onSave={() => {
              this.props.save(this.props.treeLinkStore.treeLink);
              this.props.treeLinkStore.selectedNode = undefined;
            }}
            onClose={() => this.props.treeLinkStore.selectedNode = undefined}

          />
        }
      </div>
    );
  }
}